import { render, staticRenderFns } from "./ChatterButton.vue?vue&type=template&id=543d5392&scoped=true"
import script from "./ChatterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterButton.vue?vue&type=style&index=0&id=543d5392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d5392",
  null
  
)

export default component.exports